import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from './base-service';
import { CalibrationDetectorDTO } from '../model/calibration-detector-dto';

@Injectable({
  providedIn: 'root',
})
export class SensorService extends BaseService {
  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  getObservations(
    nodeIdentifier: string,
    fromDate?: string,
    toDate?: string
  ): Promise<CalibrationDetectorDTO[]> {
    let parameters = new HttpParams();

    if (fromDate !== undefined) {
      parameters = parameters.set('fromDate', fromDate);
    }
    if (toDate !== undefined) {
      parameters = parameters.set('toDate', toDate);
    }
    let request = this.get<CalibrationDetectorDTO[]>(
      `sensor/${nodeIdentifier}`,
      parameters
    );
    return this.apiCall<CalibrationDetectorDTO[]>(request);
  }
}
